export const GET_INPUT_DATA = "GET_INPUT_DATA";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CREATE_FOLDER = "CREATE_FOLDER";
export const CREATED_FOLDER = "CREATED_FOLDER";
export const GO_BACK = "GO_BACK";
export const SCENARIAO_DATA_NEXT = "SCENARIAO_DATA_NEXT";
export const SCENARIAO_BACK = "SCENARIAO_BACK";
export const UPLOAD_SCENARIO_DATA = "UPLOAD_SCENARIO_DATA";
export const UPLOAD_BASE_LINE_DATA = "UPLOAD_BASE_LINE_DATA";
export const BASE_LINE_UPLOADING_DONE = "BASE_LINE_UPLOADING_DONE";
export const CLOSE_CREATED_FOLDER = "CLOSE_CREATED_FOLDER";
export const CLOSE_SELECTED_FOLDER = "CLOSE_SELECTED_FOLDER";
export const CLOSE_DONE_POPUP = "CLOSE_DONE_POPUP";
export const CLOSE_ERROR_POPUP = "CLOSE_ERROR_POPUP";
export const OPEN_ERROR_POPUP = "OPEN_ERROR_POPUP";
export const CLOSE_ERROR_OR_WARNING_POPUP = "CLOSE_ERROR_OR_WARNING_POPUP";
export const OPEN_ERROR_OR_WARNING_POPUP = "OPEN_ERROR_OR_WARNING_POPUP";
// Get Scenario Number
export const GET_SCENARIO_NUMBER_START = "GET_SCENARIO_NUMBER_START";
export const GET_SCENARIO_NUMBER_SUCCESS = "GET_SCENARIO_NUMBER_SUCCESS";
export const GET_SCENARIO_NUMBER_ERROR = "GET_SCENARIO_NUMBER_ERROR";

export const UPLOAD_MASTER_FILE_START = "UPLOAD_MASTER_FILE_START";
export const UPLOAD_MASTER_FILE_SUCCESS = "UPLOAD_MASTER_FILE_SUCCESS";
export const UPLOAD_MASTER_FILE_ERROR = "UPLOAD_MASTER_FILE_ERROR";

//input Folder name
export const INPUT_FOLDER_NAME = "INPUT_FOLDER_NAME";
export const BASE_LINE_UPLOADER = "BASE_LINE_UPLOADER";

export const IS_DUPLICATE_SCENARIO_CREATED = "IS_DUPLICATE_SCENARIO_CREATED";

//Base line upload
export const UPLOAD_BASE_LINE_START = "UPLOAD_BASE_LINE_START";
export const UPLOAD_BASE_LINE_SUCCESS = "UPLOAD_BASE_LINE_SUCCESS";
export const UPLOAD_BASE_LINE_ERROR = "UPLOAD_BASE_LINE_ERROR";

//Base line upload
export const UPLOAD_SCENARIO_LINE_START = "UPLOAD_SCENARIO_LINE_START";
export const UPLOAD_SCENARIO_LINE_SUCCESS = "UPLOAD_SCENARIO_LINE_SUCCESS";
export const UPLOAD_SCENARIO_LINE_ERROR = "UPLOAD_SCENARIO_LINE_ERROR";

//Create new folder
export const CREATE_NEW_FOLDER_START = "CREATE_NEW_FOLDER_START";
export const CREATE_NEW_FOLDER_SUCCESS = "CREATE_NEW_FOLDER_SUCCESS";
export const SELECTED_UPLOAD_FOLDER_ID = "FOLDER SELECTED";
export const SELECTED_UPLOAD_SCENARIO_ID = "SCENARIO SELECTED";
export const CREATE_NEW_FOLDER_ERROR = "CREATE_NEW_FOLDER_ERROR";
export const IS_FOLDER_EXISTED = "IS_FOLDER_EXISTED";

//Create new scenario
export const CREATE_NEW_SCENARIO_START = "CREATE_NEW_SCENARIO_START";
export const CREATE_NEW_SCENARIO_SUCCESS = "CREATE_NEW_SCENARIO_SUCCESS";
export const CREATE_NEW_SCENARIO_ERROR = "CREATE_NEW_SCENARIO_ERROR";
export const IS_SCENARIO_EXISTED = "IS_SCENARIO_EXISTED";

export const CREATE_FOLDER_SCENARIO_ERROR = "CREATE_FOLDER_SCENARIO_ERROR";

export const API_USER_DATA = "API_USER_DATA";
//Display Dropdown folder list
export const DISPLAY_FOLDER_LIST = "DISPLAY_FOLDER_LIST";
export const DISPLAY_FOLDER_LIST_SUCCESS = "DISPLAY_FOLDER_LIST_SUCCESS";
export const DISPLAY_FOLDER_LIST_ERROR = "DISPLAY_FOLDER_LIST_ERROR";

//Selected Dropdown folder list
export const SELECTED_FOLDER_LIST = "SELECTED_FOLDER_LIST";
export const SELECTED_FOLDER_LIST_SUCCESS = "SELECTED_FOLDER_LIST_SUCCESS";
export const SELECTED_UPLOAD_FOLDER_LIST_SUCCESS =
  "SELECTED_UPLOAD_FOLDER_LIST_SUCCESS";
export const SELECTED_FOLDER_LIST_ERROR = "SELECTED_FOLDER_LIST_ERROR";

//View Product Table Data
export const VIEW_PRODUCT_TABLE = "VIEW_PRODUCT_TABLE";
export const VIEW_PRODUCT_TABLE_SUCCESS = "VIEW_PRODUCT_TABLE_SUCCESS";
export const VIEW_PRODUCT_TABLE_ERROR = "VIEW_PRODUCT_TABLE_ERROR";

//Edit Product Table Data
export const EDIT_PRODUCT_TABLE = "EDIT_PRODUCT_TABLE";
export const EDIT_PRODUCT_TABLE_SUCCESS = "EDIT_PRODUCT_TABLE_SUCCESS";
export const EDIT_PRODUCT_TABLE_ERROR = "EDIT_PRODUCT_TABLE_ERROR";

//Display Scenario Dropdown list
export const DISPLAY_SCENARIO_LIST = "DISPLAY_SCENARIO_LIST";
export const DISPLAY_SCENARIO_LIST_SUCCESS = "DISPLAY_SCENARIO_LIST_SUCCESS";
export const DISPLAY_MONTH_NAMES_LIST_SUCCESS =
  "DISPLAY_MONTH_NAMES_LIST_SUCCESS";
export const DISPLAY_SCENARIO_LIST_ERROR = "DISPLAY_SCENARIO_LIST_ERROR";
//export const DISPLAY_MONTH_NAMES_LIST_ERROR ="DISPLAY_MONTH_NAMES_LIST_ERROR"

//Selected Scenario Dropdown list
export const SELECTED_SCENARIO_LIST = "SELECTED_SCENARIO_LIST";
export const SELECTED_SCENARIO_LIST_SUCCESS = "SELECTED_SCENARIO_LIST_SUCCESS";
export const SELECTED_SCENARIO_LIST_ERROR = "SELECTED_SCENARIO_LIST_ERROR";

//TimePeriod
export const SELECTED_TIME_PERIOD_LIST = "SELECTED_TIME_PERIOD_LIST";

//Selected Dropdown Category list
export const SELECTED_CATEGORY_LIST = "SELECTED_CATEGORY_LIST";
export const SELECTED_CATEGORY_LIST_SUCCESS = "SELECTED_CATEGORY_LIST_SUCCESS";
export const SELECTED_CATEGORY_LIST_ERROR = "SELECTED_CATEGORY_LIST_ERROR";

//Selected Dropdown Usecase list
export const SELECTED_USECASE_LIST = "SELECTED_USECASE_LIST";
export const SELECTED_USECASE_LIST_SUCCESS = "SELECTED_USECASE_LIST_SUCCESS";
export const SELECTED_USECASE_LIST_ERROR = "SELECTED_USECASE_LIST_ERROR";

//Display Dashboard Summary Cost
export const DASHBOARD_SUMMARY_COST = "DASHBOARD_SUMMARY_COST";
export const DASHBOARD_SUMMARY_COST_SUCCESS = "DASHBOARD_SUMMARY_COST_SUCCESS";
export const DASHBOARD_SUMMARY_COST_ERROR = "DASHBOARD_SUMMARY_COST_ERROR";

// Nutrition Display Dashboard Summary Cost
export const NUTRITION_DASHBOARD_SUMMARY_COST = "DASHBOARD_SUMMARY_COST";
export const NUTRITION_DASHBOARD_SUMMARY_COST_SUCCESS =
  "DASHBOARD_SUMMARY_COST_SUCCESS";
export const NUTRITION_DASHBOARD_SUMMARY_COST_ERROR =
  "DASHBOARD_SUMMARY_COST_ERROR";
export const ENABLE_EDIT = "ENABLE_EDIT";
export const DISABLE_EDIT = "DISABLE_EDIT";
export const FILE_UPLOAD_STATUS = "FILE_UPLOAD_STATUS";

export const EDIT_SCENARIO_POPUP_FLAG = "EDIT_SCENARIO_POPUP_FLAG";

// ENABLE UPLOAD FILES IN LT

export const SET_PROCESSING_PACKAGING_PL = "SET_PROCESSING_PACKAGING_PL";

export const SET_SOURCE_BE_PART_OF_OPTIMIZATION =
  "SET_SOURCE_BE_PART_OF_OPTIMIZATION";

export const SET_PROCESSING_PACKAGING_PLANT_ADD_MINOR =
  "SET_PROCESSING_PACKAGING_PLANT_ADD_MINOR";

export const LOGIN_USER_DATA = "LOGIN_USER_DATA";
